<template>
  <CCard class="mb-3">
    <CCardHeader>Mejores horarios</CCardHeader>
    <CCardBody class="p-0">
      <CDataTable
        :items="rows"
        :fields="fields"
        hover
        striped
        small
        fixed
        :items-per-page="10"
        pagination
      >
        <template #position="{ item }">
          <td class="text-center">{{ item.position }}</td>
        </template>
        <template #slot="{ item }">
          <td>{{ item.weekday_label }} {{ item.hour_label }}</td>
        </template>
        <template #sent_count="{ item }">
          <td class="text-right">{{ number(item.sent_count) }}</td>
        </template>
        <template #delivery_rate="{ item }">
          <td class="text-center">{{ percent(item.delivery_rate) }}</td>
        </template>
        <template #read_rate="{ item }">
          <td class="text-center">{{ percent(item.read_rate) }}</td>
        </template>
        <template #response_rate="{ item }">
          <td class="text-center">{{ percent(item.response_rate) }}</td>
        </template>
        <template #avg_minutes_to_read="{ item }">
          <td class="text-center">{{ minutes(item.avg_minutes_to_read) }}</td>
        </template>
        <template #avg_minutes_to_response="{ item }">
          <td class="text-center">{{ minutes(item.avg_minutes_to_response) }}</td>
        </template>
        <template #score="{ item }">
          <td class="text-center">{{ Number(item.score || 0).toFixed(3) }}</td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'BestSendTimesTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: 'position', label: '#' },
        { key: 'slot', label: 'Dia / horario' },
        { key: 'sent_count', label: 'Enviados' },
        { key: 'delivery_rate', label: 'Entrega' },
        { key: 'read_rate', label: 'Lectura' },
        { key: 'response_rate', label: 'Respuesta' },
        { key: 'avg_minutes_to_read', label: 'Tiempo a lectura' },
        { key: 'avg_minutes_to_response', label: 'Tiempo a respuesta' },
        { key: 'score', label: 'Score' },
      ],
    }
  },
  methods: {
    number(value) {
      return Number(value || 0).toLocaleString('es-MX')
    },
    percent(value) {
      return `${(Number(value || 0) * 100).toFixed(1)}%`
    },
    minutes(value) {
      if (value === null || value === undefined) {
        return 'N/D'
      }
      return `${Number(value).toFixed(1)} min`
    },
  },
}
</script>
